var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{ref:"app",style:({
    background:
      _vm.$route.name == 'LoginPage'
        ? _vm.$vuetify.theme.themes.light.background
        : _vm.$vuetify.theme.themes.light.primary,
  })},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }